import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateCollectionSharingState from '../sharing/state/collectionSharing';
import updateCollectionState from './collection';
import updateCollectionsState from './collections';
import updateDatasetCollectionsState from './datasetCollections';
import updateDCollectionDatasetsState from './collectionDatasets';

const handlers = {
  ...updateCollectionState,
  ...updateCollectionsState,
  ...updateCollectionSharingState,
  ...updateDatasetCollectionsState,
  ...updateDCollectionDatasetsState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
